export function getTotalPhones(phones) {
  return phones.split('\n')
    .map(row => row.replace(/\D/g, ''))
    .filter(row => !!row)
}

export function groupByArrayAndRemoveDuplicates(phones) {
  // Usa Set para remover duplicados (muito mais rápido que reduce)
  return Array.from(new Set(phones))
}

export function fileToCsv(str) {
  console.log('🔍 [fileToCsv] Iniciando parsing...')
  console.log('📏 [fileToCsv] Tamanho da string:', str.length)
  
  // Detecta delimitador
  const delimiter = str.indexOf(';') !== -1 ? ';' : ','
  console.log('📍 [fileToCsv] Delimitador detectado:', delimiter)
  
  // Normaliza quebras de linha
  const normalizedStr = str.replace(/\r\n/g, '\n').replace(/\r/g, '\n')
  
  const firstLineEnd = normalizedStr.indexOf('\n')
  if (firstLineEnd === -1) {
    console.error('❌ [fileToCsv] Nenhuma quebra de linha encontrada')
    return []
  }
  
  const headerLine = normalizedStr.slice(0, firstLineEnd)
  console.log('📋 [fileToCsv] Linha de cabeçalho:', headerLine)
  
  const headers = headerLine.split(delimiter).map(header => {
    let cleanHeader = String(header.trim()).toUpperCase()
    
    // Remove acentos e caracteres especiais
    cleanHeader = cleanHeader.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    
    // Remove caracteres não ASCII (como �)
    cleanHeader = cleanHeader.replace(/[^\x00-\x7F]/g, '')
    
    // Remove espaços extras
    cleanHeader = cleanHeader.replace(/\s+/g, '')
    
    return cleanHeader
  })
  console.log('📊 [fileToCsv] Headers encontrados:', headers)
  console.log('📊 [fileToCsv] Headers limpos:', headers.map(h => `"${h}"`))
  
  // Encontra o índice da coluna de número (aceita variações)
  const numeroIndex = headers.findIndex(h => {
    const cleaned = h.replace(/[^\w]/g, '').toUpperCase()
    return cleaned === 'NUMERO' || 
           cleaned === 'TELEFONE' || 
           cleaned === 'PHONE' || 
           cleaned === 'CELULAR' ||
           cleaned.includes('NUMERO') ||
           cleaned.includes('TELEFONE') ||
           cleaned.includes('NMERO')  // Para caso o ú seja removido
  })
  
  console.log('📍 [fileToCsv] Índice da coluna de número:', numeroIndex)
  
  if (numeroIndex === -1) {
    console.error('❌ [fileToCsv] Coluna de número não encontrada. Headers disponíveis:', headers)
    return []
  }
  
  const bodyStr = normalizedStr.slice(firstLineEnd + 1)
  const rows = bodyStr.split('\n').map(row => row.trim()).filter(row => row.length > 0)
  
  console.log('📊 [fileToCsv] Total de linhas (sem header):', rows.length)
  
  const result = rows.map(row => {
    const values = row.split(delimiter).map(v => v.trim())
    
    const obj = headers.reduce((object, header, i) => {
      // eslint-disable-next-line no-param-reassign
      object[header] = values[i]
      return object
    }, {})
    
    // Adiciona campo NUMERO normalizado para compatibilidade
    obj['NUMERO'] = values[numeroIndex] // eslint-disable-line
    
    return obj
  }).filter(row => {
    const numero = row['NUMERO'] // eslint-disable-line
    return numero && numero !== '' && numero !== undefined && numero !== null
  })
  
  console.log('✅ [fileToCsv] Linhas válidas com NUMERO:', result.length)
  
  return result
}

export function getPhonesFromCsv(csv) {
  // Usa Map para remover duplicados (muito mais rápido que reduce com find)
  const uniqueMap = new Map()
  
  csv.forEach(row => {
    const numero = row['NUMERO'] // eslint-disable-line
    if (numero && !uniqueMap.has(numero)) {
      uniqueMap.set(numero, row)
    }
  })
  
  return Array.from(uniqueMap.values())
}
